import script from "./AdditionalOptionsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdditionalOptionsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./AdditionalOptionsBlock.vue?vue&type=style&index=0&id=c8ba9578&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8ba9578"]])

export default __exports__